import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AuthGuard } from '~/auth/guards/auth.guard';
import { OrganizerSharedGetOrganizationByQueryIdGuard } from '~/organizer/shared/guards/get-organization-by-query-id/get-organization-by-query-id.guard';
import { OrganizerSharedGetOrganizationFromAuthUserGuard } from '~/organizer/shared/guards/get-organization-from-auth-user/get-organization-from-auth-user.guard';
import { OrganizerSharedHasOrganizationGuard } from '~/organizer/shared/guards/has-organization/has-organization.guard';
import { OrganizerSharedTimeslotResolver } from '~/organizer/shared/resolvers/timeslot/timeslot.resolver';
import { OrganizerSharedUpcomingTimeslotsResolver } from '~/organizer/shared/resolvers/timeslot/upcoming-timeslots.resolver';
import { OrganizerTimeslotEditionDeleteSelectedTimeslotsComponent } from '~/organizer/timeslot-edition/components/pages/delete-selected-timeslots/delete-selected-timeslots.component';
import { OrganizerTimeslotEditionGroupSizeComponent } from '~/organizer/timeslot-edition/components/pages/group-size/group-size.component';
import { OrganizerTimeslotEditionOffersComponent } from '~/organizer/timeslot-edition/components/pages/offers/offers.component';
import { OrganizerTimeslotEditionDateComponent } from './components/pages/date/date.component';
import { OrganizerTimeslotEditionLiveUrlComponent } from './components/pages/live-url/live-url.component';
import { OrganizerTimeslotEditionUpdateGroupSizeForSelectedTimeslotsComponent } from './components/pages/update-group-size-for-selected-timeslots/update-group-size-for-selected-timeslots.component';
import { OrganizerTimeslotEditionUpdateLiveUrlForSelectedTimeslotsComponent } from './components/pages/update-live-url-for-selected-timeslots/update-live-url-for-selected-timeslots.component';
import { OrganizerTimeslotEditionUpdateOffersForSelectedTimeslotsComponent } from './components/pages/update-offers-for-selected-timeslots/update-offers-for-selected-timeslots.component';

const routes: Routes = [
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.group-size',
    component: OrganizerTimeslotEditionGroupSizeComponent,
    resolve: {
      timeslotData: OrganizerSharedTimeslotResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.group-size/organizer.timeslot-edition.select-timeslots',
    component:
      OrganizerTimeslotEditionUpdateGroupSizeForSelectedTimeslotsComponent,
    resolve: {
      upcomingTimeslotsData: OrganizerSharedUpcomingTimeslotsResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.offers',
    component: OrganizerTimeslotEditionOffersComponent,
    resolve: {
      timeslotData: OrganizerSharedTimeslotResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.offers/organizer.timeslot-edition.select-timeslots',
    component:
      OrganizerTimeslotEditionUpdateOffersForSelectedTimeslotsComponent,
    resolve: {
      upcomingTimeslotsData: OrganizerSharedUpcomingTimeslotsResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.live-url',
    component: OrganizerTimeslotEditionLiveUrlComponent,
    resolve: {
      timeslotData: OrganizerSharedTimeslotResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.live-url/organizer.timeslot-edition.select-timeslots',
    component:
      OrganizerTimeslotEditionUpdateLiveUrlForSelectedTimeslotsComponent,
    resolve: {
      upcomingTimeslotsData: OrganizerSharedUpcomingTimeslotsResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.date',
    component: OrganizerTimeslotEditionDateComponent,
    resolve: {
      timeslotData: OrganizerSharedTimeslotResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
  {
    path: 'organizer.timeslot.manage/:id/organizer.timeslot-edition.deletion/organizer.timeslot-edition.select-timeslots',
    component: OrganizerTimeslotEditionDeleteSelectedTimeslotsComponent,
    resolve: {
      upcomingTimeslotsData: OrganizerSharedUpcomingTimeslotsResolver,
    },
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
    ],
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerTimeslotEditionRoutingModule {}
